import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import { api, constants, dateHelpers, UserContext } from '../utils';
const { ENDPOINTS } = constants;

export default function ConsignedOrderDropDownMenu(props) {
   const navigate = useNavigate();
   const userCtx = useContext(UserContext);
   const { currentUser, customerFilter } = userCtx;
   const [downloading, setDownloading] = useState(false);
   const [open, setOpen] = useState(false);

   let customerId = null;
   if (currentUser?.isAnyCustomerTypeRole) {
      customerId = currentUser.customerId;
   } else if (props.customerId || customerFilter) {
      customerId = props.customerId || customerFilter.value;
   }

   function printPackingSlip() {
      setDownloading(true)
      const payload = {
         InvoiceNumber: props.invoiceNumber,
         CustomerId: customerId,
         OrderId: props.orderId
      };
      api.postDownloadBinary(
         'Report/PackingSlip',
         payload,
         constants.MIME_TYPES.pdf,
         `Packing_List_${props.invoiceNumber ? props.invoiceNumber : props.orderId}_${dateHelpers.toMDYDateString(new Date())}.pdf`,
         "There was an error printing this packing slip"
      )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setDownloading(false));
   }

   return (
      <td
         className="data-cell"
         onMouseEnter={() => setOpen(true)}
         onMouseLeave={() => setOpen(false)}
         style={{ position: "relative" }}
      >
         <span className="shredLink fw-bold">{props.invoiceNumber || props.orderId}</span>
         <Dropdown
            isOpen={open}
            toggle={() => setOpen(!open)}
            style={{ position: "absolute", top: "1.75em", left: "2em" }}
         >
            <DropdownMenu>
               <DropdownItem className="sort-handle" onClick={printPackingSlip} disabled={downloading} >
                  Print Packing Slip
               </DropdownItem>
               {(userCtx.currentUser?.isAPUCS || userCtx.currentUser?.isSalesperson || userCtx.currentUser?.isCSRRole)
                  ? (<DropdownItem className="sort-handle">
                     <div
                        onClick={() => navigate(ENDPOINTS.createCoA, {
                           state: {
                              currentCustomer: {
                                 Customer: { value: props.customerId || (customerFilter && customerFilter.value), label: props.customerLabel },
                                 isConsignedCustomer: props.isConsigned ? true : false
                              },
                              currentOrder: { value: props.orderId, label: props.orderId },
                              currentItem: { value: props.itemNumber, label: props.itemLabel }
                           }
                        })}
                     >
                        CoA Search
                     </div>
                  </DropdownItem>)
                  : null
               }
               {userCtx.currentUser?.isAPUCS
                  || userCtx.isCSRRole
                  || userCtx.isSalesperson
                  || userCtx.isWarehouseRole
                  || userCtx.isInventoryEdit
                  ? (<DropdownItem className="sort-handle">
                     <a
                        className="text-link"
                        href={`bill-of-lading/${JSON.stringify({
                           orderId: props.orderId,
                           orderType: props.orderType,
                        })}`}
                        rel="noreferrer"
                        target="_blank"
                     >
                        Bill Of Lading
                     </a>
                  </DropdownItem>)
                  : null
               }
            </DropdownMenu>
         </Dropdown>
      </td >
   )
}